import { create } from 'zustand';

interface ToastsState {
  isInWelcomeShell: boolean;
  setIsInWelcomeShell: (value: boolean) => void;
}

export const useToastsStore = create<ToastsState>((set) => ({
  isInWelcomeShell: false,
  setIsInWelcomeShell: (value) => {
    set({ isInWelcomeShell: value });
  },
}));
